/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetRewardsLeaderboardRow } from '../openapi-types.gen.js';
import { type useGetRewardsLeaderboardArgs, useGetRewardsLeaderboardSpec } from '../specs/rewards.spec.gen.js';

export type { GetRewardsLeaderboardRow } from '../openapi-types.gen.js';
export type { useGetRewardsLeaderboardArgs } from '../specs/rewards.spec.gen.js';


export const useGetRewardsLeaderboard = createHook(useGetRewardsLeaderboardSpec);


/**
 * Hover/intent prefetch companion for `useGetRewardsLeaderboard`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetRewardsLeaderboard();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetRewardsLeaderboard = createPrefetchHook(useGetRewardsLeaderboardSpec);
